import axios from 'axios'

const state = {
    mostCategoryItems: null,
    setCurrency: null,
    itemPhotosAlbum: null,
    headerSearchBar: null,
    itemsOnDisplay: null,
    itemDetails: null,
}

const getters = {
    headerSearchBar (state) {
        return state.headerSearchBar
    },
    setCurrency (state) {
        return state.setCurrency
    },
    itemsOnDisplay (state) {
        return state.itemsOnDisplay
    },
    itemDetails (state) {
        return state.itemDetails
    },
    itemPhotosAlbum (state) {
        return state.itemPhotosAlbum
    },
    mostCategoryItems (state) {
        return state.mostCategoryItems
    },
    // console.log(Object.assign({}, activeUser))
}

const actions = {  
    async showHeaderSearchBarAction({ commit }, val) { 
        commit('HEADER_SEARCH_BAR', val)
    },
    
    async setCurrencyAction({ commit }) { 
        // fetch the manually set currency from environment variables
        let currencyObj = JSON.parse(process.env.VUE_APP_ANI_CURRENCY)
        commit('SET_CURRENCY', currencyObj)
    },
    
    async fullfilSearchAction({ commit }, searchObj) { 
        commit('ITEMS_ON_DISPLAY', null)
        let response = await axios.get(`/site-search/search/${searchObj.query}`)
        if(!response.data.error){
            commit('ITEMS_ON_DISPLAY', response.data.result)
        }
        return response.data
    },
    
    async categoryItemsAction({ commit, getters }, categoryObj) { 
        // reset the items-on-display state
        if(categoryObj.skipNumber == 0){
            commit('ITEMS_ON_DISPLAY', null)
        }
        let response = await axios.get(`/category-items/category/${categoryObj.category}/${categoryObj.skipNumber}/${categoryObj.limitNumber}`)
        if(!response.data.error){
            // merger the array contents
            let currentItems = getters.itemsOnDisplay ? getters.itemsOnDisplay : []
            let incomingItems = response.data.result
            let mergedItemsArr = [ ...currentItems, ...incomingItems ]
            commit('ITEMS_ON_DISPLAY', mergedItemsArr)
        }
        return response.data
    },

    async emptyItemsOnDisplayAction({ commit }, val) { 
        commit('ITEMS_ON_DISPLAY', null)
    },
    
    async itemDetailsAction({ commit }, itemObj) { 
        commit('ITEMS_DETAILS', null)
        let response = await axios.get(`/item-details/item/${itemObj.itemId}`)
        if(!response.data.error){
            commit('ITEMS_DETAILS', response.data.result)
        }
        return response.data
    },
    
    async itemPhotosAction({ commit }, itemObj) { 
        commit('ITEM_PHOTOS_ALBUM', null)
        let response = await axios.get(`/item-photos/album/${itemObj.itemId}`)
        if(!response.data.error){
            commit('ITEM_PHOTOS_ALBUM', response.data.result)
        }
        return response.data
    },
    
    async mostCategoryAction({ commit }) { 
        let response = await axios.get(`/most-category/counter`)
        if(!response.data.error){
            commit('MOST_CATEGORY_ITEMS', response.data.result)
        }
        return response.data
    },
}

const mutations = {
    MOST_CATEGORY_ITEMS: (state, mostCategoryItems) => (state.mostCategoryItems = mostCategoryItems),
    SET_CURRENCY: (state, setCurrency) => (state.setCurrency = setCurrency),
    ITEM_PHOTOS_ALBUM: (state, itemPhotosAlbum) => (state.itemPhotosAlbum = itemPhotosAlbum),
    HEADER_SEARCH_BAR: (state, headerSearchBar) => (state.headerSearchBar = headerSearchBar),
    ITEMS_ON_DISPLAY: (state, itemsOnDisplay) => (state.itemsOnDisplay = itemsOnDisplay),
    ITEMS_DETAILS: (state, itemDetails) => (state.itemDetails = itemDetails),
}

export default {
    state,
    getters,
    actions,
    mutations
}